export const API_RESPONSE_CODE = {
  INCORRECT_AUTH: '101',
  SUCCESS: '200',
  EXPIRED_AUTH: '201',
  NO_CONTENT: '204',
  DOES_NOT_EXIST: '404',
  INVALID_REQUEST: '400',
  SERVER_ERROR: '500',
};
